import { useEffect, useId, useRef, type ReactNode } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";

export function FacilityDialog({ title, locked, close, children }: { title: string; locked: boolean; close: () => void; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null), titleId = useId();
  const { w } = useLocale();
  useEffect(() => { const dialog = ref.current; dialog?.showModal(); return () => dialog?.close(); }, []);
  return <dialog ref={ref} className="facility-dialog" aria-labelledby={titleId} onCancel={event => { event.preventDefault(); if (!locked) close(); }}>
    <header className="facility-dialog-header"><h2 id={titleId}>{title}</h2><button type="button" autoFocus disabled={locked} aria-label={w("إغلاق", "Close")} onClick={close}><XMarkIcon aria-hidden="true" /></button></header>
    <div className="facility-dialog-content">{children}</div>
  </dialog>;
}
